module.exports = __webpack_public_path__ + "img/despacho1.bb573ff1.jpg";